<script setup>
// Define props
const props = defineProps({
    contentHeadlineConfig: {
        type: Object,
        default: () => ({}),
        validator: (rawValue) => {
            const validations = {
                title: value => value === undefined || typeof value === 'string',
                renderSplit: value => value === undefined || typeof value === 'boolean'
            }

            return Object.entries(validations).every(([key, validation]) => validation(rawValue[key]))
        }
    }
})

// Markdown
const { $md } = useNuxtApp()
const contentHeadline = computed(() => $md.renderInline(props.contentHeadlineConfig?.title || ''))

// Get content headline classes
const getContentHeadlineClass = computed(() => {
    return {
        'content-headline-split': props.contentHeadlineConfig?.renderSplit,
        'content-headline-default': !props.contentHeadlineConfig?.renderSplit
    }
})
</script>

<template>
    <h2 v-if="contentHeadlineConfig.title" :class="getContentHeadlineClass" v-html="contentHeadline" />
</template>

<style lang="scss">
.content-headline-default {
    padding-block: 0;

    @include superheadline-h1($margin: 0 0 20px);

    @include bp(medium1) {
        margin-block: 0 40px;
    }

    @include bp(large1) {
        margin-block: 0 80px;
    }
}

.content-headline-split {
    text-transform: uppercase;
    color: $content-headline;
    margin-block: 0 20px;
    padding-block-start: 20px;

    @include body1-extrabold;

    @include bp(medium1) {
        color: $body-text;
        text-transform: none;
        padding-block-start: 40px;

        @include superheadline-h1($margin: 0 0 40px);
    }

    @include bp(large1) {
        margin-block: 0 80px;
        padding-block-start: 60px;
    }

    em {
        font-style: normal;

        @include bp(medium1) {
            font-style: italic;
        }
    }
}
</style>
